import { Button, Result } from "antd";
import { Link } from "react-router-dom";

export const PageNotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Link to={"/"}>
          <Button className="bg-blue-500 text-white">Back Home</Button>
        </Link>
      }
    />
  );
};
